import React from "react";
import LocalShippingOutlined from "@mui/icons-material/LocalShippingOutlined";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { classNames } from "repoV2/utils/common/render/classNames";
import { indian_states_and_uts_dropdown_options } from "repoV2/features/Common/modules/Location/constants/indianStatesUtsData";
import ExlyInput from "repoV2/features/Common/modules/Form/modules/ExlyInput/ExlyInput";
import ExlySearchableDropdownV2 from "repoV2/features/Common/modules/Form/modules/ExlySearchableDropdownV2/ExlySearchableDrowpdownV2";
import CheckoutAccordion from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion";
import checkoutAccordianStyles from "repoV2/features/CheckoutPages/modules/CheckoutAccordion/CheckoutAccordion.module.scss";
import checkoutCommonStyles from "repoV2/features/CheckoutPages/CheckoutCommonStyles.module.scss";
import CheckoutFormGroupHeader from "repoV2/features/CheckoutPages/modules/CheckoutFormGroupHeader/CheckoutFormGroupHeader";
import { delivery_details_form_constant } from "./DeliveryDetailsFormGroup.contants";
import { useDeliveryDetailsFormGroup } from "./DeliveryDetailsFormGroup.utils";
import styles from "./DeliveryDetailsFormGroup.module.scss";

const {
    basic_details: { title },
} = delivery_details_form_constant;

const DeliveryDetailsFormGroup = () => {
    const {
        addressFieldConfig,
        cityFieldConfig,
        pinCodeFieldConfig,
        stateFieldConfig,
    } = useDeliveryDetailsFormGroup();

    return (
        <CheckoutAccordion
            defaultExpanded
            showExpandIcon={false}
            title={
                <CheckoutFormGroupHeader
                    title={title}
                    iconJSX={
                        <LocalShippingOutlined
                            className={styles.headerIconStyle}
                        />
                    }
                />
            }
            className={checkoutAccordianStyles.Wrapper}
            disabled
            classes={{
                root: checkoutAccordianStyles.formGroupRoot,
                disabled: checkoutAccordianStyles.formGroupDisabled,
            }}
            headerClasses={{
                root: checkoutAccordianStyles.headerRoot,
                content: checkoutAccordianStyles.headerContent,
                disabled: checkoutAccordianStyles.formGroupDisabled,
                expanded: checkoutAccordianStyles.formGroupExpanded,
            }}
        >
            <div className={checkoutAccordianStyles.BasicForm}>
                <ExlyInput
                    name={addressFieldConfig.name}
                    classes={{
                        helperText: checkoutCommonStyles.helperText,
                    }}
                    registerOptions={{
                        validate: addressFieldConfig.validate,
                    }}
                    placeholder={addressFieldConfig.placeholder}
                    fullWidth
                    onBlur={addressFieldConfig.blur}
                    InputProps={{
                        className: classNames(
                            checkoutCommonStyles.inputBaseText,
                            checkoutCommonStyles.inputBaseAreaText,
                            checkoutCommonStyles.inputCustomStyles
                        ),
                    }}
                    className={checkoutCommonStyles.inputCustomStyles}
                    multiline
                    rows={4}
                />
                <ExlyInput
                    name={cityFieldConfig.name}
                    classes={{
                        helperText: checkoutCommonStyles.helperText,
                    }}
                    registerOptions={{
                        validate: cityFieldConfig.validate,
                    }}
                    placeholder={cityFieldConfig.placeholder}
                    fullWidth
                    onBlur={cityFieldConfig.blur}
                    InputProps={{
                        className: checkoutCommonStyles.inputBaseText,
                    }}
                    autoComplete="country-name"
                    className={checkoutCommonStyles.inputCustomStyles}
                />
                <ExlyInput
                    name={pinCodeFieldConfig.name}
                    classes={{
                        helperText: checkoutCommonStyles.helperText,
                    }}
                    registerOptions={{
                        validate: pinCodeFieldConfig.validate,
                    }}
                    placeholder={pinCodeFieldConfig.placeholder}
                    fullWidth
                    autoComplete="postal-code"
                    onBlur={pinCodeFieldConfig.blur}
                    InputProps={{
                        className: checkoutCommonStyles.inputBaseText,
                    }}
                    className={checkoutCommonStyles.inputCustomStyles}
                />
                <div className={checkoutCommonStyles.dropdownBorderStyles}>
                    <ExlySearchableDropdownV2
                        name={stateFieldConfig.name}
                        options={indian_states_and_uts_dropdown_options}
                        placeholder={stateFieldConfig.placeholder}
                        classes={{
                            textInput: checkoutCommonStyles.inputBaseText,
                            helperText: checkoutCommonStyles.dropdownHelperText,
                            placeholder: checkoutCommonStyles.placeholderText,
                            inputRoot: checkoutCommonStyles.selectInput,
                            listbox: checkoutCommonStyles.selectMenuStyle,
                        }}
                        registerOptions={{
                            validate: stateFieldConfig.validate,
                        }}
                        onChange={stateFieldConfig.change}
                        ExpandIcon={<ExpandMore />}
                    />
                </div>
            </div>
        </CheckoutAccordion>
    );
};

export default DeliveryDetailsFormGroup;
